<template>
  <div>
    <the-header />
    <div class="animationFix">
      <slot />
    </div>
    <the-footer v-if="$route.name == 'Home'"/>
  </div>
</template>
<script>
import TheHeader from '../components/Common/TheHeader';
import TheFooter from '../components/Common/TheFooter';
export default {
  components: {
    TheHeader,
    TheFooter
  },
  created(){
    this.$axios.get('settings')
      .then(res => {
        let {localities, statuses, executives} = res.data
        this.$store.dispatch('setLocalitiesMaster', localities)
        this.$store.dispatch('setStatusesMaster', statuses)
      })
      .catch(err => console.log(err.response))
  }
}
</script>